export default __webpack_public_path__ + "static/media/market-hero-image.1b8f4562.png";